import * as React from "react";
import { ArrowLeft, Building2, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
export default function LocationsAndPavilionsInHerzliya() {
  return <section id="מיקומים-וביתנות-בהרצליה" className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          
          {}
          <div className="flex flex-col gap-6">
            <div className="inline-flex items-center gap-2 text-primary">
              <MapPin className="size-5" />
              <span className="font-semibold tracking-wide">
                מיקומים ושירותים
              </span>
            </div>
            
            <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground leading-tight">
              בתי חולים ומרכזים רפואיים בהרצליה
            </h2>
            
            <div className="flex flex-col gap-4 text-lg text-muted-foreground leading-relaxed">
              <p>
                הרצליה מהווה מוקד רפואי חשוב באזור השרון והמרכז, ומציעה שירותי בריאות מתקדמים לתושבי העיר והסביבה. המוסד הרפואי הבולט ביותר בעיר הוא הרצליה מדיקל סנטר (Herzliya Medical Center), בית חולים פרטי מהמובילים והיוקרתיים בישראל. המרכז מספק מגוון רחב של שירותים רפואיים ברמה בינלאומית, כולל ניתוחים מורכבים, טיפולים חדשניים, אבחונים מתקדמים וייעוץ של מומחים בעלי שם עולמי מכל תחומי הרפואה.
              </p>
              <p>
                בזכות הסטנדרטים הגבוהים של שירות, הציוד הטכנולוגי החדיש ביותר והצוות הרפואי המיומן, מטופלים רבים מכל רחבי הארץ בוחרים לקבל טיפול רפואי איכותי ואישי בהרצליה. אנו מבינים את החשיבות של ליווי צמוד ברגעים אלו, ולכן אנו מספקים שירותי מטפל סיעודי והשגחה צמודה למטופלים המאושפזים בהרצליה מדיקל סנטר. הצוות המסור שלנו דואג לנוחותם, לביטחונם ולרווחתם המרבית של המטופלים במהלך השהות בבית החולים, וכן מסייע בתהליך ההחלמה והשיקום לאחר השחרור הביתה.
              </p>
            </div>

            <div className="pt-4">
              <Button asChild size="lg" className="w-full sm:w-auto">
                <Link to="/NursingCareProviderInHerzliyaWithinFiveHoursPage">
                  הזמן מטפל סיעודי בהרצליה
                  <ArrowLeft className="mr-2 size-5" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="relative">
            <Card className="overflow-hidden border-border shadow-lg">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/herzliya_medical_center_facility.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/herzliya_medical_center_facility.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/herzliya_medical_center_facility.png-wvc-sizes" alt="הרצליה מדיקל סנטר - חזית המבנה" className="w-full h-[350px] md:h-[450px] object-cover" loading="lazy" />
              <CardContent className="p-6 bg-card">
                <div className="flex items-center gap-3 mb-2">
                  <Building2 className="size-6 text-primary" />
                  <h3 className="text-xl font-bold font-default text-foreground">
                    הרצליה מדיקל סנטר
                  </h3>
                </div>
                <p className="text-muted-foreground">
                  בית חולים פרטי מהמובילים בישראל, המעניק שירותי רפואה מתקדמים וטיפול אישי ברמה הגבוהה ביותר.
                </p>
              </CardContent>
            </Card>
            
            {}
            <div className="absolute -z-10 top-1/2 -translate-y-1/2 -right-8 w-64 h-64 bg-primary/5 rounded-lg blur-3xl"></div>
          </div>

        </div>
      </div>
    </section>;
}